import { layout } from 'thewest/App.routing'
import { StaticRoutes } from 'common/routing/page-definition'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

export const myHome: StaticRoutes<typeof layout, TheWestSection> = {
    '/my-home': ({ getAdTargeting }) => ({
        kind: 'page',
        heading: 'Your News',
        pageType: 'homepage',
        hideHeading: true,
        refreshOnInactive: true,
        noIndex: true,
        pageHead: {},
        adTargeting: getAdTargeting('home', 'default', 'my-home'),
        section: 'default',
        compositions: [
            {
                type: 'thor',
                props: {},
                contentAreas: {
                    main: [{ type: 'my-home', props: {} }],
                },
            },
        ],
    }),
}
